import { render } from "./ChannelInfo.vue?vue&type=template&id=017fafca&scoped=true"
import script from "./ChannelInfo.vue?vue&type=script&lang=js"
export * from "./ChannelInfo.vue?vue&type=script&lang=js"

import "./ChannelInfo.vue?vue&type=style&index=0&id=017fafca&lang=sass"
import "./ChannelInfo.vue?vue&type=style&index=1&id=017fafca&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017fafca"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QAvatar,QVirtualScroll,QItem,QItemSection,QItemLabel,QScrollArea,QList});qInstall(script, 'directives', {Ripple});
